import { pick } from "./helpers";

export const saveUserCredentials = (user, token) => {
  if (!user) {
    throw new Error("Nothing to save to Storage");
  } else {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("auth_token", token);
  }
};

export const getLoggedInUserRole = () => {
  try {
    if (!localStorage.user) {
      return {};
    }
    const { role } = JSON.parse(localStorage.user);
    return role;
  } catch (err) {
    console.log(err);
  }
};

export const getLoggedInUser = () => {
  try {
    if (!localStorage.user) {
      return {};
    }
    return JSON.parse(localStorage.user);
  } catch (err) {
    console.log(err);
  }
};

